import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disableGiftCardTopupScreen',
  initialState: true,
  reducers: {
    setDisableGiftCardTopupScreen(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisableGiftCardTopupScreen } = slice.actions;

export default slice.reducer;
